import { useMemo } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Settings, FileText, KeyRound, CreditCard, LogOut } from "lucide-react";

/**
 * Role-driven items for the yellow user menu in the Navbar.
 * Order matches product spec:
 *   admin      → Forms, Settings, Company Code, Subscription, Logout
 *   supervisor → Company Code, Settings, Forms, Logout
 *   others     → Settings, Logout
 */
export default function useUserMenuItems({ onOpenCompanyCode }) {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  return useMemo(() => {
    if (!user) return [];

    const items = [];
    if (user.role === "admin") {
      items.push(
        { label: "Forms",         icon: FileText,   onClick: () => navigate("/forms"),        testId: "menu-forms" },
        { label: "Settings",      icon: Settings,   onClick: () => navigate("/settings"),     testId: "menu-settings" },
        { label: "Company Code",  icon: KeyRound,   onClick: onOpenCompanyCode,               testId: "menu-company-code" },
        { label: "Subscription",  icon: CreditCard, onClick: () => navigate("/subscription"), testId: "menu-subscription" },
      );
    } else if (user.role === "supervisor") {
      items.push(
        { label: "Company Code",  icon: KeyRound,   onClick: onOpenCompanyCode,               testId: "menu-company-code" },
        { label: "Settings",      icon: Settings,   onClick: () => navigate("/settings"),     testId: "menu-settings" },
        { label: "Forms",         icon: FileText,   onClick: () => navigate("/forms"),        testId: "menu-forms" },
      );
    } else {
      items.push(
        { label: "Settings",      icon: Settings,   onClick: () => navigate("/settings"),     testId: "menu-settings" },
      );
    }

    items.push({
      label: "Logout", icon: LogOut, danger: true, testId: "menu-logout",
      onClick: async () => { await logout(); navigate("/"); },
    });
    return items;
  }, [user, navigate, logout, onOpenCompanyCode]);
}
